import React, { Fragment } from "react";
import Footer from "../../Shear/Footer/Footer";
import Header from "../../Shear/Header/Header";
import about from "../../../Assets/Styles/about.module.css";
import aboutImg from "../../../Assets/Images/Image/about.png";
import Head from "../../../layout/Head";
import ScrollToTop from "../../Shear/ScrollToTop";

const About = () => {
  return (
    <Fragment>
      <Head
        Title="About"
        href="/about"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | About Pages"
      />
      <Header />
      <section className="max-lg:max-w-[1000px] max-xl:max-w-[1200px] gap-5 my-32 pb-20 mx-auto">
        <div className=" ">
          <div className=" ">
            <h1 className="text-3xl font-bold mb-8">About us</h1>
            <h2 className="text-[42px] leading-[1.1428] mb-[20px] font-bold font-fira text-[#000001]">
              Unleashing Dreams in the Digital Realm: The{" "}
              <span className="text-primary"> WebNex-IT </span> Saga
            </h2>
            <p className=" px-10 max-lg:px-0  text-[#888] text-[15px] leading-[29px] font-roboto mb-4">
              Welcome aboard WebNex-IT, the beating heart of innovation,
              knowledge, and digital prowess. This isn't just a company—it's a
              powerhouse sculpting success stories and turning dreams into
              digital reality.
            </p>

            <h3 className="text-xl font-bold mb-4">
              Crafting Triumph, Pixel by Pixel
            </h3>
            <p className="px-10 max-lg:px-0  text-[#888] text-[15px] leading-[29px] font-roboto mb-4">
              In the fast-paced world of freelancing, entrepreneurship, and web
              development, WebNex-IT stands tall with a mission: to weave
              aspirations into concrete achievements. Picture our journey as a
              vibrant tapestry, intricately crafted with threads of creativity,
              unwavering dedication, and an insatiable hunger for excellence.
            </p>

            <h2 className="text-xl font-bold mb-4">
              The WebNex-IT Advantage: What Makes Us Shine
            </h2>
            <h6 className=" font-bold mb-4">Unmatched Expertise:</h6>
            <p className="px-10 max-lg:px-0  text-[#888] text-[15px] leading-[29px] font-roboto mb-4">
              Step into the WebNex-IT universe, where a team of industry
              maestros, visionary designers, and seasoned educators unite under
              a single banner. Our mission? To shatter limits and set
              unparalleled standards.
            </p>
            <h6 className=" font-bold mb-4">Pioneering Solutions:</h6>
            <p className="px-10 max-lg:px-0  text-[#888] text-[15px] leading-[29px] font-roboto mb-4">
              In the ever-evolving digital landscape, standing still is not an
              option. We thrive on innovation, consistently delivering solutions
              that not only address our clients' current needs but also predict
              the trends of tomorrow.
            </p>
            <h6 className=" font-bold mb-4">Empowering Education:</h6>
            <p className="px-10 max-lg:px-0  text-[#888] text-[15px] leading-[29px] font-roboto mb-4">
              Education is our secret weapon. Our courses transcend traditional
              lessons; they are transformative experiences crafted to elevate
              skills, instill confidence, and swing open doors to new
              possibilities.
            </p>

            <h6 className="text-xl  font-bold mb-4">
              Our Pledge: Your Success, Our North Star
            </h6>
            <p className="px-10 max-lg:px-0  text-[#888] text-[15px] leading-[29px] font-roboto mb-4">
              At WebNex-IT, your success isn't just a goal—it's our reason for
              being. We're more than service providers; we're your partners on
              the journey to attain your goals, no matter how audacious they may
              seem.
            </p>
            <h6 className="text-xl  font-bold mb-4">
              Set Sail on the Digital Odyssey
            </h6>
            <p className="px-10 max-lg:px-0  text-[#888] text-[15px] leading-[29px] font-roboto mb-4">
              Whether you're an aspiring freelancer, a trailblazing
              entrepreneur, or a business poised for online prominence,
              WebNex-IT is your guiding star in the vast digital expanse. Let's
              embark on this thrilling journey together, where every click,
              every code, and every course propels you closer to transforming
              your dreams into digital reality.
            </p>
            <p className="px-10 max-lg:px-0  text-[#888] text-[15px] leading-[29px] font-roboto">
              WebNex-IT - Where Success Takes Flight. Elevate, Innovate,
              Succeed.
            </p>

            <h2 className="text-xl font-bold my-4">Contact Information</h2>
            <p className="mb-6">
              If you have any questions about these Terms, please contact us at
              infoitghor24@gmail.com or at the following address:
            </p>
            <p className="mb-8">
              WebNex-IT
              <br />
              Bornomala High School Road (Beside Donia College)
              <br />
              Nayapara, Jatrabari, Dhaka - 1236
              <br />
            </p>
          </div>
          {/* <div className=" max-lg:w-2/4 relative">
            <div className=" max-lg:p-[15px] w-full relative mb-2">
              <div className={`${about.about_banner}`}>
                <img src={aboutImg} alt="IT Ghar" />
                <div
                  className={`${about.about_banner_count}  hidden  max-lg:block`}
                >
                  <span className="text-[60px] block leading-[60px] font-bold text-[#fff] font-fira">
                    2
                  </span>

                  <span className="text-[#fff] text-xl font-bold leading-[24px]">
                    years of experiences
                  </span>
                </div>
              </div>
              <div className={`${about.about_banner_text}`}>
                <div className="mr-4">
                  <i className="fa-solid fa-award text-[64px] text-[#191919]"></i>
                </div>
                <div>
                  <h2 className="text-[24px]  font-fira text-[#000001] font-bold">
                    Best Awarded Company
                  </h2>
                  <p className="text-[#888] text-[15px] leading-[22px]">
                    We adapt our delivery to the way your work, whether as an
                    external provider.
                  </p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
      <ScrollToTop />
      <Footer />
    </Fragment>
  );
};

export default About;
